module.exports = __webpack_public_path__ + "static/media/marker-hotel-4.b04657f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/marker-hotel-4.svg
// module id = 694
// module chunks = 6